<template>
  <div>
    <div class="card-row row" :class="{
      [alertMessageClass.alertClass]: errorMessage.length,
      infomsg: disabled,
      }">
      <Alert v-if="errorMessage.length" size="large" type="info" width="auto" trigger="click" :closable="false">
        <span v-for="error in errorMessage">{{error}}</span>
      </Alert>
      <div class="card-row-col card-col"
        @click = "routeToInvoiceDetails"
        v-for="(column, index) in sectionHeader"
        :class="column.class"
        :key="index">
        <!-- <div v-if="errorMessage.length" :class="alertClass">
          <Alert type="info" trigger="click">
            <ul>
              <li v-for="error in errorMessage"
                  :key="error"
                  class="el-alert__title is-bold">{{error}}</li>
            </ul>
            <svgicon class="infosvg" name="info" width="14" height="14" :original="true" />
          </Alert>
        </div> -->
        <span v-if="invoiceDetails[column.label]">

          <span v-if="column.label === 'status'" class="status status-icon" :class="getStatusClass()">
            {{getStatusLabel(invoiceDetails[column.label])}}
            <span v-if="invoiceDetails.discounted" class="badge">
              <svgicon name="icon-bill-discount" width="10" height="10" />
            </span>
          </span>

          <span v-else-if="column.label === 'amount'">
            {{$getIndianFormat(invoiceDetails[column.label])}}
          </span>
          <span v-else-if="column.label === 'age'">
            <span :class= "invoiceDetails.agedInvoice ? 'text-red' : ''">
              {{invoiceDetails[column.label]}}
            </span>
          </span>
          <span v-else-if="column.label=== 'payment_due_date'">
            <span :class="invoiceDetails.discounted?'text-green':''">{{invoiceDetails[column.label]}}</span>
          </span>
          <span v-else-if="invoiceDetails[column.label]">
            <Ellipsis v-if="column.truncateOn"
            :text="invoiceDetails[column.label]"
            :length="column.truncateOn" />
            <span v-else>{{invoiceDetails[column.label]}}</span>
          </span>
        </span>
        <span v-else-if="invoiceDetails[column.label] === 0">0</span>
        <span v-else> - </span>
      </div>
      <!-- TODO : fix the spacing issue after details text -->
      <div class="card-row-col card-col ml-auto">
        <div @click="showDetails(index)" class="pointer action-link"
             :class="{ [alertMessageClass.detailsClass]: errorMessage.length }">
          <svgicon name="details" width="12" height="12" />
          <span class="card-actionlabel">{{ $t('DETAILS_SLIDER') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import { mapGetters } from 'vuex';
import { InvoiceStatusUtils } from 'status-utils';
import { getDateDiff } from '@/lib/Date';
import { status, alerts, invoiceStatus } from '@/constants/payments';
import { isInvoiceSignatureEnabled } from '@common/lib/payments';
import Details from './Details';

export default {
  props: {
    invoice: {
      type: Object,
      required: true,
    },
    sectionHeader: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
    blockingDueToAgedInvoice: {
      type: Boolean,
      default: false,
    },
    invoiceAgeWindow: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Details,
  },
  data() {
    return {
      Details: {},
      errorMessage: [],
      alerts,
      alertMessageClass: {},
    };
  },
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      currentClientConfig: 'app/currentClientConfig',
      currentTransporter: 'app/currentTransporter',
    }),
    invoiceDetails() {
      const invoiceDetails = {
        invoiceId: this.invoice.invoice_number,
        status: this.getStatus(this.invoice.status) && this.getStatus(this.invoice.status).name,
        invoiceSignature: this.invoice.invoice_signature_status,
        amount: this.invoice.amount,
        is_digital_invoice_enabled: this.invoice.is_digital_invoice_enabled || false,
      };
      if (this.invoice.date !== null) {
        const date = this.invoice.date;
        invoiceDetails.age = getDateDiff(moment(), date).toString();
        invoiceDetails.date = moment(date).format('DD MMM YYYY');
      }
      if (this.invoice.status !== null) {
        if (this.invoice.status === 0) {
          invoiceDetails.status = this.invoice.custom_status;
          invoiceDetails.rejected = this.invoice.rejected;
        } else {
          invoiceDetails.status = this.getStatus(this.invoice.status) &&
            this.getStatus(this.invoice.status).name;
        }
      }
      if (this.invoice.payment_due_date !== null) {
        const date = this.invoice.payment_due_date;
        invoiceDetails.payment_due_date = moment(date).format('DD MMM YYYY');
      }
      if (this.invoiceAgeWindow) {
        invoiceDetails.agedInvoice = invoiceDetails.age >= this.invoiceAgeWindow;
      }
      invoiceDetails.discounted = !!this.invoice.discount_amount;
      return invoiceDetails;
    },
    disabled() {
      /**
       * if we have atleast one aged return invoice,
       * disable all other invoices except aged return invoices
       */
      this.errorMessage = [];
      if (this.invoiceDetails.status === 'Rejected') {
        this.alertMessageClass = this.alerts.ALERT_RED;
        this.errorMessage.push(this.$getErr('ACTION_PENDING_ON_SHIPPER'));
      }
      if (this.invoiceDetails.status === 'Cancelled') return true;
      const disableRow = this.blockingDueToAgedInvoice
          && ((this.invoice.status === 4 && !(this.invoiceDetails.agedInvoice))
          || this.invoice.status !== 4);
      if (disableRow) {
        this.alertMessageClass = this.alerts.ALERT_RED;
        this.errorMessage.push(this.$getErr('CLEAR_AGED_RETURN_INVOICES'));
      }
      if (isInvoiceSignatureEnabled(this.currentClientConfig) && !this.currentTransporter.e_invoice_verify && (this.invoiceDetails.is_digital_invoice_enabled || this.invoiceDetails.status === 'Checked')) {
        if (!this.invoiceDetails.invoiceSignature) {
          this.alertMessageClass = this.alerts.ALERT_RED;
          this.errorMessage.push(this.$getErr('INVOICE_UPLOAD_NEEDED'));
        } else if (this.invoiceDetails.invoiceSignature === 'TRANSPORTER_UPLOADED_DIGITAL_SIGNATURE') {
          this.alertMessageClass = this.alerts.ALERT_GREEN;
          this.errorMessage.push(this.$getErr('INVOICE_VERIFICATION_NEEDED'));
        }
      }
      return disableRow;
    },
  },
  methods: {
    update() {
      this.isOpenUpdate = true;
    },
    getStatus(id) {
      return status.find(i => i.ids && i.ids.includes(id));
    },
    getStatusClass() {
      const type = (this.invoice.status === 0) ? {
        color: this.invoice.rejected ? 'red' : 'blue',
      } : this.getStatus(this.invoice.status);
      return type && `status-${type.color.toLowerCase()}`;
    },
    showDetails(index) {
      this.$emit('showDetails', index);
    },
    routeToInvoiceDetails() {
      if (!this.disabled) {
        if (!this.invoice.id) {
          this.$router.push({ name: 'invoiceDetails' });
        } else {
          this.$router.push({ name: 'invoiceDetails', params: { id: this.invoice.id } });
        }
      }
    },
    getStatusLabel(label) {
      let statusLabel;
      if (this.invoice.status === invoiceStatus.CUSTOM && this.invoice.rejected) {
        if (label.toUpperCase() ===
          InvoiceStatusUtils.getStatusObjByName('invoice_approved').label.toUpperCase()) {
          statusLabel = 'Approver Rejected';
        } else if (label.toUpperCase() ===
          InvoiceStatusUtils.getStatusObjByName('checked').label.toUpperCase()) {
          statusLabel = 'Checker Rejected';
        } else {
          statusLabel = `${label} Rejected`;
        }
      } else {
        statusLabel = label;
      }
      return statusLabel;
    },
  },
};
</script>
